import React from 'react';
import { vercel_base_url } from '../../../../util/config';

export const LINKS = {
  privacyPolicy: (
    <a
      href={`${vercel_base_url}/pages/privacy-policy`}
      target="_blank"
      rel="noreferrer"
    >
      Privacy Policy
    </a>
  ),
  termsOfUse: (
    <a
      href={`${vercel_base_url}/pages/bombas-terms-and-conditions-of-use`}
      target="_blank"
      rel="noreferrer"
    >
      Terms of Use
    </a>
  )
};

export default {};
